import * as images from './images'
import * as imagesNew from './imagesNew'
import * as imagesMen from './imagesMen'

import messages from './messages'


const womanQuizData = [
  {
    name: 'quiz1',
    title: messages.step1Title,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'bakery',
        img: images.bakery,
        name: messages.bakery,
        value: false,
      },
      {
        id: 'flowerShop',
        img: images.flowerShop,
        name: messages.flowerShop,
        value: false,
      },
      {
        id: 'orangeGrove',
        img: images.orangeGrove,
        name: messages.orangeGrove,
        value: false,
      },
      {
        id: 'privateLibrary',
        img: images.privateLibrary,
        name: messages.privateLibrary,
        value: false,
      },
      {
        id: 'seaShore',
        img: images.seaShore,
        name: messages.seaShore,
        value: false,
      },
      {
        id: 'spiceMarket',
        img: images.spiceMarket,
        name: messages.spiceMarket,
        value: false,
      },
    ],
  },
  {
    name: 'quiz2',
    title: messages.step2Title,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'berries',
        img: images.berries,
        name: messages.berries,
        value: false,
      },
      {
        id: 'chocolate',
        img: images.chocolate,
        name: messages.chocolate,
        value: false,
      },
      {
        id: 'flowers',
        img: images.flowers,
        name: messages.flowers,
        value: false,
      },
      {
        id: 'incense',
        img: images.incense,
        name: messages.incense,
        value: false,
      },
      {
        id: 'leather',
        img: images.leather,
        name: messages.leather,
        value: false,
      },
      {
        id: 'oranges',
        img: images.oranges,
        name: messages.oranges,
        value: false,
      },
      {
        id: 'suede',
        img: images.suede,
        name: messages.suede,
        value: false,
      },
      {
        id: 'wood',
        img: images.wood,
        name: messages.wood,
        value: false,
      },
    ],
  },
  {
    name: 'quiz3',
    title: messages.step3Title,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'cocktail',
        img: images.cocktail,
        name: messages.cocktail,
        value: false,
      },
      {
        id: 'coffee',
        img: images.coffee,
        name: messages.coffee,
        value: false,
      },
      {
        id: 'milkShake',
        img: images.milkShake,
        name: messages.milkShake,
        value: false,
      },
      {
        id: 'smoothie',
        img: images.smoothie,
        name: messages.smoothie,
        value: false,
      },
      {
        id: 'tea',
        img: images.tea,
        name: messages.tea,
        value: false,
      },
      {
        id: 'water',
        img: images.water,
        name: messages.water,
        value: false,
      },
      {
        id: 'wine',
        img: images.wine,
        name: messages.wine,
        value: false,
      },
      {
        id: 'wiskey',
        img: images.wiskey,
        name: messages.wiskey,
        value: false,
      },
    ],
  },
]

const subscriptionQuizData = [
  {
    name: 'quiz1',
    title: messages.step1NewTitle,
    subTitle: messages.step1SubTitle,
    tags: [
      {
        id: 'fineFragrance',
        img: imagesNew.fineFragrance,
        name: messages.fineFragrance,
        value: false,
      },
      {
        id: 'bodyWash',
        img: imagesNew.bodyWash,
        name: messages.bodyWash,
        value: false,
      },
      {
        id: 'bubbleBath',
        img: imagesNew.bubbleBath,
        name: messages.bubbleBath,
        value: false,
      },
      {
        id: 'soapBars',
        img: imagesNew.soapBars,
        name: messages.soapBars,
        value: false,
      },
      {
        id: 'bodyOil',
        img: imagesNew.bodyOil,
        name: messages.bodyOil,
        value: false,
      },
      {
        id: 'bodyLotion',
        img: imagesNew.bodyLotion,
        name: messages.bodyLotion,
        value: false,
      },
    ],
  },
  {
    name: 'quiz2',
    title: messages.step2NewTitle,
    subTitle: messages.step2SubTitle,
    tags: [
      {
        id: 'handCare',
        img: imagesNew.handCare,
        name: messages.handCare,
        value: false,
      },
      {
        id: 'sunCare',
        img: imagesNew.sunCare,
        name: messages.sunCare,
        value: false,
      },
      {
        id: 'antiBacterial',
        img: imagesNew.antiBacterial,
        name: messages.antiBacterial,
        value: false,
      },
      {
        id: 'deodorant',
        img: imagesNew.deodorant,
        name: messages.deodorant,
        value: false,
      },
      {
        id: 'conditioner',
        img: imagesNew.conditioner,
        name: messages.conditioner,
        value: false,
      },
      {
        id: 'dryShampoo',
        img: imagesNew.dryShampoo,
        name: messages.dryShampoo,
        value: false,
      },
    ],
  },
  {
    name: 'quiz3',
    title: messages.step2NewTitle,
    subTitle: messages.step2SubTitle,
    tags: [
      {
        id: 'candle',
        img: imagesNew.candle,
        name: messages.candle,
        value: false,
      },
      {
        id: 'diffuser',
        img: imagesNew.diffuser,
        name: messages.diffuser,
        value: false,
      },
      {
        id: 'toner',
        img: imagesNew.toner,
        name: messages.toner,
        value: false,
      },
      {
        id: 'lipBalm',
        img: imagesNew.lipBalm,
        name: messages.lipBalm,
        value: false,
      },
      {
        id: 'faceWash',
        img: imagesNew.faceWash,
        name: messages.faceWash,
        value: false,
      },
      {
        id: 'faceMask',
        img: imagesNew.faceMask,
        name: messages.faceMask,
        value: false,
      },
    ],
  },
  {
    name: 'quiz4',
    title: messages.step2NewTitle,
    subTitle: messages.step2SubTitle,
    tags: [
      {
        id: 'serum',
        img: imagesNew.serum,
        name: messages.serum,
        value: false,
      },
      {
        id: 'eyeCream',
        img: imagesNew.eyeCream,
        name: messages.eyeCream,
        value: false,
      },
      {
        id: 'wipes',
        img: imagesNew.wipes,
        name: messages.wipes,
        value: false,
      },
      {
        id: 'supplements',
        img: imagesNew.supplements,
        name: messages.supplements,
        value: false,
      },
      {
        id: 'makeup',
        img: imagesNew.makeup,
        name: messages.makeup,
        value: false,
      },
      {
        id: 'nailCare',
        img: imagesNew.nailCare,
        name: messages.nailCare,
        value: false,
      },
    ],
  },
]

const menQuizData = [
  {
    name: 'quiz1',
    title: messages.step1TitleMen,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'golfing',
        img: imagesMen.golfing,
        name: messages.golfing,
        value: false,
      },
      {
        id: 'hiking',
        img: imagesMen.hiking,
        name: messages.hiking,
        value: false,
      },
      {
        id: 'meditating',
        img: imagesMen.meditating,
        name: messages.meditating,
        value: false,
      },
      {
        id: 'sailing',
        img: imagesMen.sailing,
        name: messages.sailing,
        value: false,
      },
      {
        id: 'sightseeing',
        img: imagesMen.sightseeing,
        name: messages.sightseeing,
        value: false,
      },
      {
        id: 'snowboarding',
        img: imagesMen.snowboarding,
        name: messages.snowboarding,
        value: false,
      },
    ],
  },
  {
    name: 'quiz2',
    title: messages.step2Title,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'cinnamon',
        img: imagesMen.cinnamon,
        name: messages.cinnamon,
        value: false,
      },
      {
        id: 'coffee',
        img: imagesMen.coffee,
        name: messages.coffee,
        value: false,
      },
      {
        id: 'leather',
        img: imagesMen.leather,
        name: messages.leather,
        value: false,
      },
      {
        id: 'lemons',
        img: imagesMen.lemons,
        name: messages.lemons,
        value: false,
      },
      {
        id: 'spices',
        img: imagesMen.spices,
        name: messages.spices,
        value: false,
      },
      {
        id: 'woods',
        img: imagesMen.woods,
        name: messages.woods,
        value: false,
      },
    ],
  },
  {
    name: 'quiz3',
    title: messages.step3Title,
    subTitle: messages.subTitle,
    tags: [
      {
        id: 'beer',
        img: imagesMen.beer,
        name: messages.beer,
        value: false,
      },
      {
        id: 'bloodyMarry',
        img: imagesMen.bloodyMarry,
        name: messages.bloodyMarry,
        value: false,
      },
      {
        id: 'mojito',
        img: imagesMen.mojito,
        name: messages.mojito,
        value: false,
      },
      {
        id: 'scotch',
        img: imagesMen.scotch,
        name: messages.scotch,
        value: false,
      },
      {
        id: 'water',
        img: imagesMen.water,
        name: messages.water,
        value: false,
      },
      {
        id: 'wine',
        img: imagesMen.wine,
        name: messages.wine,
        value: false,
      },
    ],
  },
]

export {
  womanQuizData,
  subscriptionQuizData,
  menQuizData,
}
